import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

const props = {
  agriOptions: [
    { key: 'Ag', label: 'Agricultural expansion', description: 'Expansion of agricultural land' },
    { key: 'Gr', label: 'Grassland expansion', description: 'Expansion of grassland' }
  ],
  afforestOptions: [
    { key: 'Bi', label: 'Bioenergy', description: 'Expansion of forest for bioenergy (short rotation native broadleaf)' },
    { key: 'En', label: 'Environmental benefit', description: 'Expansion of forest for environmental benefit (enhancing forest connectivity, preventing runoff, improving access to forested areas)' },
    { key: 'Co', label: 'Commercial timber', description: 'Expansion of forest for commercial timber production (mixed coniferous and broadleaf)' },
    { key: 'Ag', label: 'Agroforestry', description: 'Expansion of agroforestry on arable and pasture systems' }
  ],
  cropOptions: [
    { key: 'Na', label: 'Same as today', description: 'Current cropping regime' },
    { key: 'Int', label: 'Intensive', description: 'Intensive cropping regimes to maximise production and profit' },
    { key: 'Ext', label: 'Extensive', description: 'Extensive cropping regime that minimises inputs of agrochemicals and capital' },
    { key: 'Div', label: 'Diverse', description: 'Diverse cropping regimes where a landscape of diverse crops is maximised' }
  ],
  grassOptions: [
    { key: 'Na', label: 'Same as today', description: 'Current grassland management regime' },
    { key: 'Int', label: 'Intensive', description: 'Increase stocking rates, shift to intensive beef and dairy on highly improved pastures' },
    { key: 'Ext', label: 'Extensive', description: 'Reduce stocking rates, shift to less intensive dairy and sheep' },
    { key: 'Div', label: 'Diverse', description: 'Shift to mixed systems with intermediate stocking of beef, dairy and sheep' }
  ],
  mapOptions: [
    { key: 'landcover', label: 'Land cover', description: 'Dominant land cover type per 1km cell' },
    { key: 'landcover_change', label: 'Land cover change', description: 'Identifies which 1km cells have changed land cover under the selected scenario' },
    { key: 'crop', label: 'Crop', description: 'Dominant crop types grown per 1km square' },
    { key: 'grass', label: 'Grassland', description: 'Dominant grassland management per 1km square' }
  ],
  summaryOptions: [
    { key: 'gb', label: 'Great Britain', type: 'top' },
    { key: 'eng', label: 'England', type: 'top' },
    { key: 'scotland', label: 'Scotland', type: 'top' },
    { key: 'wales', label: 'Wales', type: 'top' },
    { key: 'euroregions', label: 'Select region from map', type: 'top', multiRegion: true }
  ],
  variableOptions: [
    { key: 'Aesthetics', description: 'Diversity of habitats visible from public viewpoints' },
    { key: 'Birds (farmland)', description: 'Abundance index for farmland birds' },
    { key: 'Birds (woodland)', description: 'Abundance index for woodland birds' },
    { key: 'Calories', label: 'Calories', description: 'Human-edible calories produced from crops and livestock' },
    { key: 'Connectivity (grassland)', description: 'Inverse cost-distance to semi-natural grassland  areas' },
    { key: 'Connectivity (woodland)', description: 'Inverse cost-distance to broadleaf woodland areas' },
    { key: 'Income', description: 'Net income from crop and livestock sales' },
    { key: 'Natural Enemies', description: 'Species richness of pest-predatory carabids and ladybirds' },
    { key: 'Nitrogen Retention', description: 'Retention of nitrogen from watercourses' },
    { key: 'Phosphorus Retention', description: 'Retention of phosphorus from watercourses' },
    { key: 'Pollinators', description: 'Species richness of pollinating bees' },
    { key: 'Soil Carbon', description: 'Topsoil (15 cm) carbon' }
  ]
}

ReactDOM.render(<App {...props} />, document.getElementById('root'))
